<template>
  <div class="noWrap">      
    <v-btn icon color="primary"  @click.stop="dialog = true"  >
      <v-icon center>mdi-truck</v-icon>
    </v-btn>  
    <v-dialog v-model="dialog"  :content-class="$vuetify.breakpoint.xsOnly ? 'sideBarMobile' : 'sidebarDialog'">
      <v-card-title style="position: absolute">
        <v-spacer></v-spacer>
        <v-btn @click="closeModal()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
        <iframe style="width:100%; height: 100%; overflow-y: scroll;" :src="`${url}`" title="Drivein"/>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'FacturacionTrackingComponent',
  props: {
    value: {
      type: [String, Boolean, Array, Number],
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {
          // eslint-disable-next-line no-unused-vars
          transform: (value, row) => value,
        }
      },
    },
    row: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      dialog: false,
      urlDriveIn: config.APP_DRIVEIN_TRACK_URL
    }
  },
  methods: {
    closeModal() {
      this.dialog = false
      this.$emit('update:dialog', false)
    },
  },
  computed: {
    url() {
      if (this.dialog) {
        return `${this.urlDriveIn}${this.row.CUSTOMER_PO}`
      }
      return '' 
    }
  },
}
</script>
<style lang="sass" >
.sidebarDialog 
  background: white !important
  border-radius: 4px !important
  box-shadow: 2px 1px 10px rgba(15, 15, 15, 0.15) !important
  height: 75% !important
  margin: 0 !important
  max-height: 100% !important
  padding: 0 !important
  position: fixed !important
  top: 10% !important
  width: 52vw !important
  overflow: hidden

.sideBarMobile
  width: 100vw !important
  height: 100vh !important
  top: 0 !important
  margin: 0px !important
</style>